import React from 'react';
import { useMenu } from 'react-instantsearch';

const MenuSelect = ({ attribute }) => {
    const { items, refine } = useMenu({ attribute });
    const { value: currentRefinement } = items.find((item) => item.isRefined) || {
        value: '',
    };

    const itemsSorted = items.sort((a, b) => {
        const yearA = a.label;
        const yearB = b.label;

        if (yearA < yearB) {
            return 1;
        }
        if (yearA > yearB) {
            return -1;
        }

        return 0;
    });

    return (
        <div className="cards__sidebar cards__sidebar--search">
            <h4 className="heading -tight">Filter by Date</h4>
            <select
                value={currentRefinement || ''}
                onChange={(event) => refine(event.currentTarget.value)}
                className="menuDropdown menuDropdown__select"
            >
                <option value="">All Years</option>
                {itemsSorted.map((item) => (
                    <option key={item.label} value={item.isRefined ? currentRefinement : item.value}>
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default MenuSelect;
